import { HistogramConfigurationProviderProps } from 'features/drilldown/components/histogram/contexts/HistogramConfigurationContext'
import { HistogramPanelData } from 'features/drilldown/components/histogram/DrilldownHistogram'

const LATEST_DATA_SCHEMA_VERSION = 3

export const DEFAULT_ASSET_TYPE_HISTOGRAM_PANEL_DATA: HistogramPanelData = {
  panelDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
  title: 'Asset Types',
  isPinned: true,
  selectedBarIds: [],
  groupingColumn: 'asset-model.type',
  aggregationColumn: 'asset-model.type',
  aggregationOperation: 'count',
}

export const ASSET_TYPE_HISTOGRAM_CONFIG_PROPS: HistogramConfigurationProviderProps =
  {
    defaultPanelData: DEFAULT_ASSET_TYPE_HISTOGRAM_PANEL_DATA,
    latestDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
  }
